import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=ced1086a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=ced1086a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced1086a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ced1086a')) {
      api.createRecord('ced1086a', component.options)
    } else {
      api.reload('ced1086a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=ced1086a&scoped=true&", function () {
      api.rerender('ced1086a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KW6ZRbP2D3HY/JS/comp/SearchFilterTokens.vue"
export default component.exports